module.exports = __webpack_public_path__ + "img/m_add-person.f48fba0f.png";